import { getFormattedTime, getRollup} from './Helpers';
import { ChevronRight } from 'tabler-icons-react';
 
interface FlightListProps {
  updateSelectedFlight: (arg: any) => void,
  flights: any,
  isDarkTheme: boolean
}

export const FlightList = (props: FlightListProps) => {
  if (props.flights != '') {
    const rows = props.flights.map((item: any) => (
      <table key={item.flightPlanId} onClick={((e) => props.updateSelectedFlight(item))} className='flights' style={{ borderBottom: '1px solid lightgrey', backgroundColor: 'rgb(0.0, 122.0, 255.0, 0.6)'}}>
        <tbody>
          <tr>
            <td style={{paddingLeft:'3%'}}>
              <strong>{item.properties.auto_aircraft_id_field_name}</strong>
            </td>
            <td style={{paddingLeft:'10%'}}>
              {getRollup(item.properties, 'targetOffBlockTimeRollup')}
            </td> 
          </tr>
          <tr>
            <td style={{paddingLeft:'3%'}}>
              {item.properties.tail_number_field_name}
            </td>
            <td style={{paddingLeft:'10%'}}>
              {getRollup(item.properties, 'targetStartupApprovalTimeRollup')}
              <ChevronRight size={20} color={props.isDarkTheme ? 'white' : 'grey'} style={{float:'right', marginRight:'5%'}}/>
            </td> 
          </tr>
          <tr>
            <td style={{paddingLeft:'3%'}}>
              {item.properties.assigned_gate_aerobahn_field_name_short} | {item.properties.dest_airport_field_name}
            </td>
              <td style={{paddingLeft:'10%'}}>
              CTOT: {getFormattedTime(item.properties.edct_aerobahn)}
            </td>
          </tr>
        </tbody>
      </table>
    ));
    return (
      <div>
      {rows}
      </div>
    );
  } else {
    return (
      <div></div>
    );
  }
}
